import { Breadcrumb, Button, Card, Col, Flex, Row, Space, Tabs } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg";
import dayjs from "dayjs"
import AnnualPND1ReportModal from "../reportModal/AnnualPND1ReportModal";

const { MainLayout } = require("components/layouts")

const AnnualPND1ReportComponent = ({
    pdfUrl,
    pdf2Url,
    showReport,
    positionOptions = [],
    departmentOptions = [],
    isModalOpen = false,
    showModal = () => { },
    setIsModalOpen = () => { },
    handleSearch = () => { },
    exportAnnualPND1ReportExcel = () => { },
    exportAnnualPND3ReportExcel = () => { },
    searchValues,
    isDownload = false,
    setMode = () => { },
    mode,
}) => {
    const { t } = useTranslation();

    return (
        <MainLayout>
            <AnnualPND1ReportModal
                mode={mode}
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                exportAnnualPND1ReportExcel={mode == "M01" ? exportAnnualPND1ReportExcel : exportAnnualPND3ReportExcel}
                searchValues={searchValues}
                isDownload={isDownload}
            />

            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t("report.header"), href: "" },
                        { title: t("salary_calculation_group.header"), href: "" },
                        { title: t("annual_pnd.header") }
                    ]} />
                    <h2>{t("annual_pnd.header")}</h2>
                </Flex>

                <FormAntd
                    onFinish={handleSearch}
                    initialValues={{ year: dayjs() }}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical gap={16}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                        multiple={true}
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="year"
                                                        dateFormat={"YYYY"}
                                                        picker="year"
                                                        label={t('payroll_period.label.tax_year')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        required
                                                    // onChange={(value, info) => {
                                                    //     console.log("log onChange", value, info);

                                                    //     setFieldValue("year", value);
                                                    //     setFieldValue("periodId", null);
                                                    //     updatePeriodOptions({
                                                    //         year: value,
                                                    //         month: getFieldValue("month"),
                                                    //         employmentTypeId: getFieldValue("employmentTypeId")
                                                    //     })
                                                    //     setYear(value?.year?.())
                                                    // }}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px", marginTop: "24px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {(
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <Tabs
                                                    destroyInactiveTabPane
                                                    defaultActiveKey={mode}
                                                    onChange={(e) => {
                                                        console.log("e", e);
                                                        setMode(e)
                                                    }}
                                                >
                                                    <Tabs.TabPane
                                                        tab={t('pdng1')}
                                                        key="M01"
                                                    >
                                                        {showReport && (
                                                            <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                                                <Flex justify="end">
                                                                    <Button type="default" style={{ height: "40px", borderRadius: "8px" }}
                                                                        onClick={showModal}
                                                                    >
                                                                        <Flex gap={8}>
                                                                            <DownloadIcon />
                                                                            <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                                        </Flex>
                                                                    </Button>
                                                                </Flex>

                                                                <iframe
                                                                    src={pdfUrl}
                                                                    title="PND1 Report Preview"
                                                                    width="100%"
                                                                    height="600px"
                                                                    style={{
                                                                        border: "1px solid #ccc",
                                                                        borderRadius: "8px",
                                                                        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
                                                                    }}
                                                                />

                                                            </Space>
                                                        )}

                                                    </Tabs.TabPane>

                                                    <Tabs.TabPane
                                                        tab={t('pdng3')}
                                                        key="M02"
                                                    >
                                                        {showReport && (
                                                            <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                                                <Flex justify="end">
                                                                    <Button type="default" style={{ height: "40px", borderRadius: "8px" }}
                                                                        onClick={showModal}
                                                                    >
                                                                        <Flex gap={8}>
                                                                            <DownloadIcon />
                                                                            <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                                        </Flex>
                                                                    </Button>
                                                                </Flex>

                                                                <iframe
                                                                    src={pdf2Url}
                                                                    title="PND3 Report Preview"
                                                                    width="100%"
                                                                    height="600px"
                                                                    style={{
                                                                        border: "1px solid #ccc",
                                                                        borderRadius: "8px",
                                                                        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
                                                                    }}
                                                                />

                                                            </Space>
                                                        )}
                                                    </Tabs.TabPane>
                                                </Tabs>

                                                {/* <TableAntd
                                                        columns={columns}
                                                        dataSource={reportSection50BisTable}
                                                        rowKey={(record) => record.id}
                                                        onChange={onChange}
                                                        pagination={pagination}
                                                    /> */}

                                            </Card>
                                        </Space >
                                    )}

                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    )
}

export default AnnualPND1ReportComponent;